// extracted by mini-css-extract-plugin
export default {"banner":"webpack-pages-StudyList-components-LibkeyNomadMigration-LibkeyNomadMigration-module__banner"};